import { useState } from 'react';
import { Radio, RadioGroup, FormControl, FormControlLabel, Stack } from '@mui/material';
import { useLocalization } from 'localization';

type Props = {
  options: Array<{ label: string; value: string; isDisable?: boolean }>;
  onChange: (value: string) => void;
  defaultValue: number | string | { label: string; value: string };
  direction?: 'row' | 'column';
  disabled?: boolean;
};

const RadioSelect = (props: Props) => {
  const { options, onChange, defaultValue, direction = 'column', disabled = false } = props;
  const initialValue = typeof defaultValue === 'object' ? defaultValue.value : defaultValue;
  const [selectedValue, setSelectedValue] = useState(initialValue);
  const { t } = useLocalization();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSelectedValue(value);
    onChange(value);
  };

  return (
    <FormControl component="fieldset" fullWidth>
      <RadioGroup value={selectedValue} onChange={handleChange}>
        <Stack direction={direction} spacing={1}>
          {options.map(option => (
            <FormControlLabel
              disabled={disabled}
              key={option.value}
              value={option.value}
              control={<Radio disabled={option.isDisable} />}
              label={t(option.label)}
            />
          ))}
        </Stack>
      </RadioGroup>
    </FormControl>
  );
};

export default RadioSelect;
